import LinearGradient from "react-native-linear-gradient"
import React from "react"
import { VoucherContainerProp } from "./props"
import { style } from "./styles"
import { useColor } from "app/theme/getThemes"
import AnimatedNewBadge from "components/AnimatedNewBadge"
import { Text } from "components/Text"
import { View, Image, TouchableOpacity } from "react-native"
import moment from "moment"
import { translate } from "i18n"
import Svg, { Line } from "react-native-svg"
import expired from "../../../assets/expired.png"
import claimed from "../../../assets/claimed-img.png"

const VoucherContainer = (props: VoucherContainerProp) => {
  const {
    voucherName,
    voucherDescription,
    voucherPointReq,
    voucherImg,
    voucherStartDate,
    isHistory,
    voucherExpiredDate,
    useAt,
    isPromotion,
    onPress,
    currentLocation,
  } = props

  const { companyTheme } = useColor()
  const today = moment()
  const startDate = moment(voucherStartDate)
  const endDate = startDate.clone().add(7, "days")
  const isSevenDayFromStart = today.isBetween(startDate, endDate, "days", "[]")

  return (
    <>
      <TouchableOpacity onPress={onPress}>
        <LinearGradient
          style={style.voucherContentContainer}
          colors={[companyTheme.first, companyTheme.second]}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 0 }}
        >
          {isHistory || currentLocation === "voucher"
            ? null
            : isSevenDayFromStart && <AnimatedNewBadge />}

          <View style={style.row}>
            <View style={style.voucherContainer}>
              <Text style={style.voucherTitleText} numberOfLines={2}>
                {voucherName}
              </Text>

              {currentLocation === "voucher" && (
                <Text style={style.expiryText}>
                  {isHistory
                    ? `${
                        useAt
                          ? translate("voucherScreen.usedOn")
                          : translate("voucherScreen.expiredOn")
                      } ${moment(useAt || voucherExpiredDate).format("DD-MM-YYYY")}`
                    : `${translate("voucherScreen.expiry")}: ${moment(voucherExpiredDate).format(
                        "DD-MM-YYYY",
                      )}`}
                </Text>
              )}

              <View style={style.dottedLine}>
                <Svg height="2" width="100%">
                  <Line
                    x1="0"
                    y1="0"
                    x2="100%"
                    y2="0"
                    stroke="white"
                    strokeWidth="2"
                    strokeDasharray="5, 4" // Adjust dash length and spacing
                  />
                </Svg>
              </View>

              {voucherPointReq > 0 && !isHistory && (
                <Text style={style.voucherText}>{voucherPointReq + " pts"}</Text>
              )}
              <Text style={style.voucherText} numberOfLines={1}>
                {voucherDescription}
              </Text>
            </View>

            <View style={{ width: 90 }}>
              {!(currentLocation === "voucher") ? (
                <Image
                  source={{
                    uri: voucherImg,
                  }}
                  resizeMode="cover"
                  style={style.image}
                />
              ) : (
                <>
                  {isHistory ? (
                    <>
                      <Image
                        source={{
                          uri: voucherImg,
                        }}
                        resizeMode="cover"
                        style={[style.image, { tintColor: "gray" }]}
                      />
                      <Image
                        source={{
                          uri: voucherImg,
                        }}
                        resizeMode="cover"
                        style={[style.image, { opacity: 0.3, position: "absolute" }]}
                      />
                    </>
                  ) : (
                    <Image
                      source={{
                        uri: voucherImg,
                      }}
                      resizeMode="cover"
                      style={style.image}
                    />
                  )}
                </>
              )}
            </View>
          </View>

          {!isPromotion && (
            <>
              <View style={style.leftCurved}></View>
              <View style={style.rightCurved}></View>
            </>
          )}
        </LinearGradient>
        {/* expired and claimed */}

        {currentLocation === "voucher" &&
          !isHistory &&
          moment(useAt).isBefore(moment().add(15, "minutes")) && (
            <Image
              source={require("../../../assets/countdown.gif")}
              resizeMode="contain"
              style={[style.expiredClaimedImage, { opacity: 1 }]}
            />
          )}

        {isHistory && (currentLocation === "voucher" || currentLocation === "forYou") ? (
          <Image
            source={useAt ? claimed : expired}
            resizeMode="cover"
            style={style.expiredClaimedImage}
          />
        ) : null}
      </TouchableOpacity>
    </>
  )
}

export default VoucherContainer
